import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Card, Form, Button } from 'react-bootstrap';
const uuid = require('uuid');
const _ = {
    find: require('lodash/find'),
    forEach: require('lodash/forEach'),
    map: require('lodash/map'),
};

import GenericKeyValueTextPairInputModal from '../modal/GenericKeyValueTextPairInputModal';


const VoiceActions = require('../../actions/VoiceActions');
const VoiceStore = require('../../stores/VoiceStore');
import ErrorBox from '../common/ErrorBox';
import SortableTable2 from '../table/SortableTable2';
import AccessibleIcon from '../common/AccessibleIcon';

const propTypes = {
    engine: PropTypes.string.isRequired,
};

const defaultProps = {};

class AdminVoiceEnableDisablePanel extends React.Component {
    constructor(props) {
        super(props);
        let voices = VoiceStore.getVoicesForEngine(props.engine) || [];
        this.state = {
            getVoicesActionId: null,
            voices,
        };

        this.unsubscribes = [VoiceStore.listen(this.onVoiceStoreChange.bind(this))];
    }
    
    componentDidMount() {
        if (!this.state.voices.length) {
            this.getVoices();
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onVoiceStoreChange(storeState) {
        if (storeState.action.id === this.state.getVoicesActionId) {
            let voices = VoiceStore.getVoicesForEngine(this.props.engine) || [];
            this.setState({voices, getVoicesActionId:null});
        }
        else if (storeState.action.id === this.state.changeVoiceActionId) {
            let voices = VoiceStore.getVoicesForEngine(this.props.engine) || [];
            this.setState({voices, changeVoiceActionId:null});
        }
    }

    getVoices() {
        const getVoicesActionId = uuid.v4();
        let options = {};
        switch(this.props.engine) {
            case 'elevenlabs':
                options.elevenlabs = true;
                break;
            case 'cartesia':
                options.cartesia = true;
                break;
        }
        
        this.setState({ getVoicesActionId}, () => {
            VoiceActions.getVoices(getVoicesActionId, options);
        });
    }
    
    setVoiceDisabled=(Id,disable)=>{
        const changeVoiceActionId = uuid.v4();
        let engine = this.props.engine;
        this.setState({ changeVoiceActionId}, () => {
            VoiceActions.adminSetVoiceIdDisabled(changeVoiceActionId, {engine, Id, disable});
        });
    }
    
    deleteVoiceCategory=(Id,category_name)=>{
        const changeVoiceActionId = uuid.v4();
        let engine = this.props.engine;
        let row = _.find(this.state.voices,{Id});
        if (!row) {
            return;
        }
        let categories = row.categories;
        if (categories) {
            delete categories[category_name];
            this.setState({ changeVoiceActionId }, () => {
                VoiceActions.adminSetVoiceIdCategories(changeVoiceActionId, {engine, Id, categories});
            });
        }
    }

    setVoiceCategoryValue=(Id,name,value)=>{
        const changeVoiceActionId = uuid.v4();
        let engine = this.props.engine;
        let row = _.find(this.state.voices,{Id});
        if (!row) {
            return;
        }
        let categories = row.categories;
        if (!categories) {
            categories = {};
        }
        categories[name] = value;
        this.setState({ changeVoiceActionId }, () => {
            VoiceActions.adminSetVoiceIdCategories(changeVoiceActionId, {engine, Id, categories});
        });
    }

    
    setModalState=(modalState)=>{
        this.setState({modalState});
    }
    
    renderModalState=()=>{
        if (!this.state.modalState) {
            return null;
        }
        if (this.state.modalState.type === 'addVoiceCategory') {
            let Id = this.state.modalState.data;
            return (
                <GenericKeyValueTextPairInputModal 
                    title="add category"
                    pairName="category"
                    onClose={()=>{
                        this.setModalState(null);
                    }}
                    onConfirm={(name,value)=>{
                        this.setVoiceCategoryValue(Id,name,value);
                        this.setState({modalState: null});
                    }}/>
            )
        }
        return null;
    }

    render() {
        const busy = (this.state.getVoicesActionId || this.state.changeVoiceActionId) ? true : false;
        // sanitize rows
        let rows = _.map(this.state.voices,(ve)=>{
            return {
                Id: ve.Id,
                Name: ve.Name,
                Gender: ve.Gender,
                disabled: !!ve.disabled,
                categories: ve.categories || {},
            }
        });
        return (
            <div>
                <h3>{`${this.props.engine} Voices`}</h3>
                <ErrorBox error={this.state.error}/>
                <SortableTable2
                    key="raw-data-table"
                    title={`${this.props.engine} voices`}
                    uniqueRowKey="Id"
                    rows={rows}
                    selectedRowKey={this.state.selected_index}
                    columns={
                        [
                            {
                                displayName: 'Id',
                                key:'Id',
                                size: 1,
                                type: 'number'
                            },
                            {
                                displayName: 'Name',
                                key:'Name',
                                size: 1,
                                type: 'string'
                            },
                            {
                                displayName: 'Gender',
                                key:'Gender',
                                size: 1,
                                type: 'string'
                            },
                            {
                                displayName: 'categories',
                                key:'categories',
                                size: 1,
                                type: 'custom'
                            },
                            {
                                displayName: 'disabled',
                                key:'disabled',
                                size: 1,
                                type: 'bool'
                            },
                            {
                                displayName: 'Disable',
                                key:'disable_entry',
                                size: 1,
                                type: 'custom'
                            },
                        ]
                    }
                    displayColumnCallbacks={{
                        categories: (dummy,Id)=>{
                            let row = _.find(this.state.voices,{Id});
                            let disabled = row.disabled;
                            let categories = row ? row.categories : {};
                            let items = [];
                            _.forEach(categories,(v,k)=>{
                                items.push(
                                    <li key={k}>
                                        <span>{`${k}: ${v}`}</span>
                                        { disabled ? null :
                                        <button className="table-button" title="enable" disabled={busy} onClick={()=>{this.deleteVoiceCategory(Id,k)}}>
                                            <AccessibleIcon className="fa fa-trash table-button" label="delete name/value pair"/>
                                        </button>
                                        }
                                    </li>
                                )
                            });
                            if (!disabled) {
                                items.push(
                                    <li key='_add_'>
                                        <button className="table-button" title="enable" disabled={busy} 
                                            onClick={
                                                ()=>{
                                                    this.setModalState({ 
                                                        type: 'addVoiceCategory', 
                                                        data: Id 
                                                    })
                                                }
                                            }>
                                            <AccessibleIcon className="fa fa-plus-circle table-button" label="add name/value pair">
                                                Add
                                            </AccessibleIcon>
                                        </button>
                                    </li>
                                );
                            }
                            return (<ul>{items}</ul>);
                        },
                        disable_entry: (dummy,Id)=>{
                            let row = _.find(this.state.voices,{Id});
                            let disabled = row && row.disabled;
                            if (disabled) {
                                return (
                                    <button className="table-button" title="enable" disabled={busy} onClick={()=>{this.setVoiceDisabled(Id,false)}}>
                                        <AccessibleIcon className="fa fa-undo table-button" label="enable voice">
                                            Enable
                                        </AccessibleIcon>
                                    </button>
                                )
                            }
                            return (
                                <button className="table-button" title="disable" disabled={busy} onClick={()=>{this.setVoiceDisabled(Id,true)}}>
                                    <AccessibleIcon className="fa fa-trash table-button" label="disable voice">
                                        Disable
                                    </AccessibleIcon>
                                </button>
                            )
                        },
                    }}
                    
                />
                { this.renderModalState() }
            </div>
        )
    }
}

AdminVoiceEnableDisablePanel.propTypes = propTypes;
AdminVoiceEnableDisablePanel.defaultProps = defaultProps;

export default AdminVoiceEnableDisablePanel;